import { FormTemplate } from "components/modal/templates";
import React from "react";
import { config, initialState } from "./config";

class SyncSystemForm extends FormTemplate {
    sendRequest = (stateData) => {
        delete stateData.userDisplayName;
        delete stateData.isValid;
        return this.props.update(stateData);
    };

    renderBodyInner = () => {
        const { config } = this.props;
        return (
            <>
                {this.renderSelect(config.userId)}
                {this.renderField(config.key)}
                {this.renderSelect(config.behavior)}
                {this.renderSelect(config.trackingType)}
            </>
        );
    };
}

const ConfiguredModal = (props) => (
    <SyncSystemForm {...props} config={config} initialState={props.data || initialState} />
);

export default ConfiguredModal;
